import { useFieldHelper } from 'framework/ui/field';
import { CustomBadge } from 'framework/ui/ui-builder';
import { SERVICE_CATALOG_STATUSES, SERVICE_CATALOG_STATUSES_OPTIONS } from 'domain/shared/serviceCatalog';

type ServiceCatalogStatusBadgeProps = {
  source: string;
};

const ServiceCatalogStatusBadge = ({ source, ...props }: ServiceCatalogStatusBadgeProps) => {
  const { getValue } = useFieldHelper({ source });
  const status = getValue() as keyof typeof SERVICE_CATALOG_STATUSES;

  if (status !== SERVICE_CATALOG_STATUSES.ARCHIVED) {
    return null;
  }

  const text = SERVICE_CATALOG_STATUSES_OPTIONS[status];
  const color = 'default';

  if (!text) {
    return null;
  }

  return <CustomBadge text={text} color={color} {...props} />;
};

export default ServiceCatalogStatusBadge;
